
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'LinkBlock',
  mixins: [staticBlockMixin]
})
